/**
 * Designs queries
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const getFonts = graphql(
  gql`
    query GetFonts {
      fonts: getFonts {
        id
        family
        active
      }
    }
  `,
  { name: 'fontsData' }
)

export const getProdesignItemQuery = gql`
  query getProdesignItem($shortId: String!, $deviceInfo: DeviceObjectInput) {
    projectItem: getProdesignItem(shortId: $shortId, deviceInfo: $deviceInfo) {
      id: short_id
      status
      code: design_code
      showNotification
      commentsNotifications
      requirePrint: require_print
      requireReason: require_reason
      limitRequests: limit_requests
      paidRequests: paid_requests
      desiredVinyl: desired_vinyl
      desiredPredyed: desired_predyed
      role
      product {
        id
        productId: id
        yotpoId: yotpo_id
        name
        active
        discontinued
        modelSize: model_size
        type: short_description
        onlyProDesign: only_pro_design
        shortDescription: short_description
        genderId: gender_id
        customizable: design_center
        description
        details
        hideFitStyles: hide_fit_styles
        youthCombined: youth_combined
        relatedItemTag: related_item_tag
        materials: materials_info
        temperatures: temperature_range
        twoPieces: two_pieces
        collections
        isTopProduct
        predyedlabel
        bibBraceFullPrint: bibrace_fullprint
        branding
        hasPredyed: has_predyed
        zipperName: zipper_name
        zipper2Name: zipper2_name
        intendedUse: intended_use
        obj
        mtl
        label
        bumpMap: bump_map
        flatlock
        glb
        glbEnabled: glb_enabled
        extraMaterials: extra_materials
        flatlock_glb
        bibraceWhite_glb: bib_brace_white_glb
        bibraceNormal_glb: bib_brace_normal_glb
        bibraceBlack_glb: bib_brace_black_glb
        bindingWhite_glb: binding_white_glb
        bindingBlack_glb: binding_black_glb
        branding_glb_png
        binding {
          white
          black
        }
        zipper {
          white
          black
        }
        zipper2 {
          white
          black
        }
        bibBrace {
          white
          black
        }
        genders {
          id
          name: gender
        }
        fitStyles {
          id
          name: description
          info
        }
        sizeRange: size_range {
          id
          name
          isYouth: is_youth
        }
        images: original_pictures {
          front: front_image
          back: back_image
          left: left_image
          right: right_image
          genderId: gender_id
          colorId: color_id
        }
        priceRange {
          price
          quantity
          abbreviation
          shortName: short_name
        }
      }
      design {
        id 
        shortId: short_id 
        name 
        shared 
        image 
        code 
        canvas 
        style_id 
        outputSvg: output_svg 
        createdAt: created_at
        canvas_files
        zipFile: zip_file
        pro_design
        preflight_check
        proDesign: pro_design
        proCertified: pro_certified
        vinyl
        stitchingValue: flatlock
        predyedName: predyed_name
        stitchingName: flatlock_code
        zipperColor: zipper_color
        zipper2Color: zipper2_color
        bindingColor: binding_color
        bibColor: bib_brace_color
        high_resolution
        requirePrintApproval: require_print_approval
        outputPng: output_png
        colors {
          id
          color
        }
        user {
          firstName: first_name
          lastName: last_name
        }
      }
      testPrintData(fromApprovalCenter: true) {
        shortId: short_id
      }
      testPrints(fromApprovalCenter: true) {
        id
        file
        shortId: short_id
        ticketCode: ticket_code
        ticketShortId: ticket_short_id
        uploadedBy: uploaded_by
        uploadedAt: uploaded_at
        activatedBy: activated_by
        activatedAt: activated_at
        activated
        visibleBy: visible_by
        visibleAt: visible_at
        visible
        approvedBy: approved_by
        approvedAt: approved_at
        approved
        rejectNote: reject_note
        rejectedBy: rejected_by
        rejectedAt: rejected_at
        code
      }
      colors {
        name
        value
      }
      messages {
        id
        createdAt: created_at
        type
        message
        file
        design
        code
        paid
        requireAnswer: require_answer
        parentMessageId: parent_message_id
        answer {
          message
        }
        userName: user_name
      }
      project {
        id
        name
        notes
        shortId: short_id
        teamSize: team_size
        status
        createdAt: created_at
        updatedAt: updated_at
        customer
        customerEmail: customer_email
        members {
          id
          shortId: short_id
          userId: user_id
          firstName: first_name
          lastName: last_name
          accountManager: account_manager
          dateInvited: date_invited
          dateAdded: date_added
          role
          projectId: project_id
          email
        }
        designs {
          id: short_id
          name
          code
          createdAt: created_at
          image
          status
          product {
            id
            code
            name
            shortDescription: short_description
            pictures: original_pictures {
              front: front_image
              thumbnail
            }
          }
          lastTask: lastTaskCustomer {
            date
            type
          }
        }
        files {
          id
          fileUrl: file_url
          original: original_file
        }
        palette {
          id
          shortId: short_id
          name
          primaryColor: primary_color
          accent1: accent_1
          accent2: accent_2
          accent3: accent_3
          accent4: accent_4
        }
        inspiration {
          id
          name
          image
          tags
        }
      }
    }
  }
`

export const addProMessageMutation = gql`
  mutation sendNoteProdesign(
    $itemId: String!,
    $message: String!,
    $file: String,
    $parentMessageId: String
  ) {
    messageData: sendNoteProdesign(
      itemId: $itemId,
      message: $message,
      file: $file,
      parentMessageId: $parentMessageId
    ) {
      id
      createdAt: created_at
      type
      message
      code
      file
      design
      paid
      parentMessageId: parent_message_id
      requireAnswer: require_answer
      userName: user_name
      answer {
        message
      }
    }
  }
`

export const addProductProjectMutation = gql`
  mutation addProductProject(
    $project: String!,
    $product: Int!,
    $message: String!,
    $file: String,
    $desiredPredyed: String, 
    $desiredVinyl: String,
  ) {
    addProductProject(
      project: $project,
      product: $product,
      message: $message,
      file: $file,
      desiredPredyed: $desiredPredyed, 
      desiredVinyl: $desiredVinyl,
    ) {
      shortId: short_id
    }
  }
`

export const approveDesignMutation = gql`
  mutation setApproveDesign($itemId: String!, $memberManager: String) {
    messageData: setApproveDesign(itemId: $itemId, memberManager: $memberManager) {
      id
      status
    }
  }
`

export const getPredyedColors = gql`
  query getPredyedColors {
    getPredyedColors {
      id: short_id
      name
      code
    }
    resellerProfile: getResellerProfile {
      businessCategory: business_category
      status
      comission
      currency
    }
  }
`

export const getVariantsFromProduct = gql`
  query getVariants($id: Int!) {
    getVariants(id: $id) {
      id: short_id
      name
      icon
      default: is_default
      obj
      mtl
      glb
    }
  }
`

export const addTeamStoreItemMutation = gql`
  mutation AddTeamStoreItem(
    $teamStoreItem: TeamStoreItem!
    $teamStoreId: String!
  ) {
    addTeamStoreItem(
      teamStoreItem: $teamStoreItem
      teamStoreId: $teamStoreId
    ) {
      message
    }
  }
`

export const sendInvitationsMutation = gql`
  mutation sendInvitations(
    $projectId: String!
    $emails: [String]!
    $projectItemId: String!
  ) {
    sendInvitations(
      projectId: $projectId
      emails: $emails
      projectItemId: $projectItemId
    ) {
      message
    }
  }
`

export const reSendInvitationsMutation = gql`
  mutation reSendInvitation(
    $projectId: String!
    $email: String!
    $projectItemId: String!
  ) {
    reSendInvitation(
      projectId: $projectId
      email: $email
      projectItemId: $projectItemId
    ) {
      message
    }
  }
`

export const changeMemberRoleMutation = gql`
  mutation changeMemberRole(
    $role: String!
    $memberId: String!
  ) {
    changeMemberRole(
      role: $role
      memberId: $memberId
    ) {
      message
    }
  }
`

export const deleteMemberMutation = gql`
  mutation deleteMember($memberId: String!) {
    deleteMember(memberId: $memberId) {
      message
    }
  }
`

export const getEditRequestPrices = gql`
  query getEditRequestPrices {
    editRequestPrices: getEditRequestPrices {
      usd
      aud
      cad
      eur
      chf
      gbp
    }
  }
`

export const getProdesignItemCommentsQuery = gql`
  query getProdesignItemComments($shortId: String!) {
    projectComments: getProdesignItemComments(shortId: $shortId) {
      id
      createdAt: created_at
      message
      file
      userName: user_name
      userSerialId: user_serial_id
      userId: user_id
      likes
      hearts
      owner
      parentMessageId: parent_message_id
      parent {
        id
        userSerialId: user_serial_id
        userName: user_name
        message
      }
    }
  }
`

export const sendCommentMutation = gql`
  mutation sendComment(
    $itemId: String!,
    $message: String!,
    $file: String,
    $parentMessageId: String
  ) {
    messageData: sendComment(
      itemId: $itemId,
      message: $message,
      file: $file,
      parentMessageId: $parentMessageId
    ) {
      id
      createdAt: created_at
      message
      file
      userName: user_name
      userId: user_id
      likes
      hearts
    }
  }
`

export const updateReactionMutation = gql`
  mutation updateReaction($messageId: Int!, $isHeart: Boolean) {
    updateReaction(messageId: $messageId, isHeart: $isHeart) {
      message
    }
  }
`

export const commentsSubscription = gql`
  subscription comments {
    messageAdded {
      id
      text
    }
  }
`

export const rejectPrintMutation = gql`
  mutation rejectPrint($shortId: String!, $rejectNote: String!, $fromProDesign: Boolean) {
    rejectPrint(shortId: $shortId, rejectNote: $rejectNote, fromProDesign: $fromProDesign) {
      message
    }
  }
`

export const approvePrintMutation = gql`
  mutation approvePrint($shortId: String!, $fromProDesign: Boolean) {
    approvePrint(shortId: $shortId, fromProDesign: $fromProDesign) {
      message
    }
  }
`

export const getFeePrices = gql`
  query getFeePrices {
    designInfo: getDesignLabInfo(onlyData: true) {
      deliveryDaysPrint: delivery_days_print
      deliveryDaysPhoto: delivery_days_photo
    }
    testPrintPrices: getTestPrintPrices {
      usd
      aud
      cad
      eur
      chf
      gbp
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignApproval/data.ts